import { createSlice } from '@reduxjs/toolkit';
import { PatientList } from "./PatientList";

const WorkersSlice = createSlice({
    name: 'main',
    initialState: PatientList,
    reducers: {
        addItem: (state, action) => {
            state.push(action.payload);
        },
    },
});

export const { addItem } = WorkersSlice.actions;
export default WorkersSlice;